export default __webpack_public_path__ + "static/media/platformDefault.85eb0403.png";